import { getError } from '@/utils/helpers';
import SubgroupService from '@/services/SubgroupService';

export const namespaced = true;

function setPaginatedSubgroups(commit, response) {
  commit('SET_SUBGROUPS', response.data.data);
  commit('SET_META', response.data.meta);
  commit('SET_LINKS', response.data.links);
  setSuccess(commit);
}

function setSubgroup(commit, response) {
  commit('SET_SUBGROUP', response.data.data);
  commit('SET_META', response.data.meta);
  setSuccess(commit);
}

function setMessage(dispatch, message) {
  dispatch('ui/snackbarSuccess', message, { root: true });
}

function setSuccess(commit) {
  commit('SET_LOADING', false);
  commit('SET_SUCCESS', true);
}

function setError(dispatch, commit, error) {
  commit('SET_LOADING', false);
  commit('SET_SUCCESS', false);
  commit('SET_ERROR', error);
  dispatch('ui/snackbarError', error, { root: true });
}

export const state = {
  subgroups: [],
  subgroup: {},
  meta: null,
  links: null,
  loading: false,
  error: null,
  success: false
};

export const mutations = {
  SET_SUBGROUPS(state, subgroups) {
    state.subgroups = subgroups;
  },
  SET_SUBGROUP(state, subgroup) {
    state.subgroup = subgroup;
  },
  SET_META(state, meta) {
    state.meta = meta;
  },
  SET_LINKS(state, links) {
    state.links = links;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_SUCCESS(state, success) {
    state.success = success;
  }
};

export const actions = {
  list({ dispatch, commit }, options) {
    commit('SET_LOADING', true);
    SubgroupService.list(options)
      .then(response => {
        setPaginatedSubgroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  organisation({ dispatch, commit }, options) {
    commit('SET_LOADING', true);
    SubgroupService.organisation(options.organisation_id)
      .then(response => {
        setPaginatedSubgroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  person({ dispatch, commit }, options) {
    commit('SET_LOADING', true);
    SubgroupService.person(options.person_id)
      .then(response => {
        setPaginatedSubgroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  get({ dispatch, commit }, options) {
    commit('SET_LOADING', true);
    SubgroupService.get(options.id, options)
      .then(response => {
        setSubgroup(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  save({ dispatch, commit }, data) {
    commit('SET_LOADING', true);
    SubgroupService.save(data.id, data.subgroup)
      .then(response => {
        setSubgroup(commit, response);
        setMessage(dispatch, 'Saved subgroup');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async peopleAttach({ dispatch, commit }, props) {
    commit('SET_LOADING', true);
    return SubgroupService.peopleAttach(props.subgroup_id, props.person_id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Host attached');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async peopleDetach({ dispatch, commit }, props) {
    commit('SET_LOADING', true);
    return SubgroupService.peopleDetach(props.subgroup_id, props.person_id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Host detached');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async hostAttach({ dispatch, commit }, props) {
    commit('SET_LOADING', true);
    return SubgroupService.hostAttach(props.subgroup_id, props.organisation_id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Host attached');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async hostDetach({ dispatch, commit }, props) {
    commit('SET_LOADING', true);
    return SubgroupService.hostDetach(props.subgroup_id, props.organisation_id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Host detached');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async delete({ dispatch, commit }, id) {
    commit('SET_LOADING', true);
    return SubgroupService.delete(id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Saved subgroup');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  paginate({ dispatch, commit }, link) {
    commit('SET_LOADING', true);
    SubgroupService.paginate(link)
      .then(response => {
        setPaginatedSubgroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  }
};

export const getters = {
  subgroups: state => {
    return state.subgroups;
  },
  subgroup: state => {
    return state.subgroup;
  },
  meta: state => {
    return state.meta;
  },
  links: state => {
    return state.links;
  },
  loading: state => {
    return state.loading;
  },
  error: state => {
    return state.error;
  },
  success: state => {
    return state.success;
  }
};
